import React, { Component } from 'react'
import '../BranchMangement/BranchListContainer.css'
import { Container, Row, Col } from 'reactstrap'
import ObjectPermissionsList from "./ObjectPermissionsList"
import NewObjectPermissionModal from "./NewObjectPermissionModal"
import RestrictedSection from "../../Components/RestrictedSection"
class ObjectPermissionsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            searchTerm: "",
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_groupobjectpermission">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={{ offset: 4, size: 8 }} className="text-right mt-2">
                            <a className="driver-list-button" onClick={() => this.toggleModal("newObjectPermissionModal")}>
                                Create Object Permission | <i className="fa fa-user-plus" aria-hidden="true"></i>
                            </a>
                            {this.state.openModal === "newObjectPermissionModal" && <NewObjectPermissionModal handleClose={() => this.toggleModal("newObjectPermissionModal")} open={this.state.openModal === "newObjectPermissionModal"} />}
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <ObjectPermissionsList searchTerm={this.state.searchTerm ? this.state.searchTerm : ""} />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}

export default ObjectPermissionsListContainer